import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import LxcError from "~/core/models/LxcError.class";
import platformIdCardService from "~/core/services/platformIdCard.service";
import { downloadJsonFile } from "~/core/utils/download.utils";
import { NotificationKey } from "~/core/utils/notifications";

export function useDownloadPlatformIdCard({
  organizationCode,
  businessUnitCode,
}: {
  organizationCode?: number;
  businessUnitCode?: number;
}) {
  let service = platformIdCardService.getOrganizationPlatformIdCard.bind(
    platformIdCardService,
  );
  if (businessUnitCode) {
    service = platformIdCardService.getBusinessUnitPlatformIdCard.bind(
      platformIdCardService,
    );
  }
  const code = computed(() => businessUnitCode ?? organizationCode);
  const isLoading = ref(false);
  const { can } = useAcl();

  async function downloadPlatformIdCard() {
    isLoading.value = true;

    const response = await service(code.value);
    if (LxcError.check(response)) {
      response.notify(NotificationKey.error);
    } else {
      downloadJsonFile(response, "platform-id-card.json");
    }

    isLoading.value = false;
  }

  const canDownloadPlatformIdCard = () => {
    return can(ACLRoles.CAN_READ_LICENSE) || can(ACLRoles.CAN_READ_ORG);
  };

  return {
    isLoading,
    downloadPlatformIdCard,
    canDownloadPlatformIdCard,
  };
}
